import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export const Layout = ({ children, withFooter = true }) => (
  <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    {withFooter && <Footer />}
  </div>
);
